import "./AboutUsCardRight.css";

const AboutUsCardRight = ({ data }) => {
	return (
		<div className="about-us-card-right-container">
			<h4 className="about-us-card-right-text">
				{data["texts"].map((text, index) => {
					if (text["style"] === "br") {
						return <br key={index} />;
					} else if (text["style"] === "bold") {
						return (
							<span key={index} style={{ fontWeight: "bold" }}>
								{text["value"]}
							</span>
						);
					} else {
						return text["value"];
					}
				})}
			</h4>
			<div className="about-us-card-right-image">
				<img
					alt={data["alt"]}
					src={require("../../assets/" + data["image"])}
					className="about-us-card-right-image-img"
				/>
			</div>
		</div>
	);
};

export default AboutUsCardRight;
